import { LaneHistoryTable } from "../../../dispatch/src/LaneHistoryTable";
import { RateIndexDataSummary } from "../../../dispatch/src/RateIndexDataSummary";
import { CommitmentAutoRating } from "../CommitmentAutoRating";
import { TenderRates } from "../TenderRates";
import { Button, CityState, DataSource, HorizontalSpacer, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiSuggestedPricing extends Layout {
    buttonClear: Button;
    buttonExpand: Button;
    citystateConsigneeCS: CityState;
    citystateCustomer: CityState;
    citystateShipperCS: CityState;
    citystateStopOriginCityId: CityState;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelCongineeCaption: Label;
    labelCustomerAddress: Label;
    labelCustomerCaption: Label;
    labelCustomerName: Label;
    labelDeliveryCaption: Label;
    labelEdiStopConsigneeSchedArriveEarly: Label;
    labelEdiStopConsigneeSchedArriveEarlyTime: Label;
    labelEdiStopConsigneeSchedArriveLate: Label;
    labelEdiStopOriginSchedArriveEarly: Label;
    labelEdiStopOriginSchedArriveEarlyTime: Label;
    labelEdiStopOriginSchedArriveLate: Label;
    labelFilter: Label;
    labelPickupCaption: Label;
    labelShipperCaption: Label;
    layoutCommitmentAutoRating: CommitmentAutoRating;
    layoutEdiSPRatePanel: Layout;
    layoutLaneHistory: LaneHistoryTable;
    layoutRateIndex: RateIndexDataSummary;
    layoutTenderRates: TenderRates;
    panel1: Panel;
    panelCommodity: Panel;
    panelCustomer: Panel;
    panelFilterComponents: Panel;
    panelOverview: Panel;
    panelPickupDelivery: Panel;
    panelSearchFilter: Panel;
    panelSearchHeader: Panel;
    panelShipperConsignee: Panel;
    panelWeightDistance: Panel;
    searchButton: Button;
    sourceEdiOrdersList: DataSource;
    sourceEdiStop: DataSource;
    sourceLaneHistory: DataSource;
    sourceOtherChargeEdi: DataSource;
    sourceRateIndexControl: DataSource;
    tabCommitmentAutoRating: Tab;
    tabLaneHistory: Tab;
    tabRateIndex: Tab;
    tabsetEdiSuggestedPricing: Tabset;
    textboxBillDistance: Textbox;
    textboxBillDistanceUm: Textbox;
    textboxCommodityId: Textbox;
    textboxDateRange: Textbox;
    textboxEquipmentType: Textbox;
    textboxEquipmentTypeId: Textbox;
    textboxMovementStatus: Textbox;
    textboxRadius: Textbox;
    textboxRevenueCode: Textbox;
    textboxStopsPickDrop: Textbox;
    textboxWeight: Textbox;
    textboxWeightUm: Textbox;
}
